import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  Companies: any;
  Url = 'https://account.youco-it.com/';
  AppId = 'f9417e99-4faa-43c1-a8a6-3563401dccc6';
  constructor() {}

  getUser() {
    return !!localStorage.getItem('x-api-key');
  }

  login() {
    window.location.href = this.Url + 'application/' + this.AppId + '?logout=true';
  }
  logout() {
    localStorage.removeItem('x-api-key');
    window.location.reload();
  }
}
